import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { default as InitialsAvatar } from "react-avatar";

import { avatar } from "assets/icons";
import { AvatarContainer } from "./Avatar.styles";

export const Avatar = ({
  height,
  size = "medium",
  width,
  src = null,
  showBorder = false,
  name,
  round = false,
  className = "",
  ...props
}) => {
  const [showInitial, setShowInitial] = useState(false);

  useEffect(() => {
    setShowInitial(false);
  }, [src]);

  const setInitials = () => setShowInitial(true);

  const getAvatarSize = () => {
    if (typeof size === "number") return size;
    switch (size) {
      case "small":
        return 28;
      case "large":
        return 99;
      default:
        return 48; // medium
    }
  };

  return !src || showInitial ? (
    <div className={className}>
      <InitialsAvatar
        name={name}
        src={!name ? avatar : ""}
        round={round}
        size={getAvatarSize()}
        {...props}
      />
    </div>
  ) : (
    <AvatarContainer
      {...props}
      className={[
        `${className} avatar-${typeof size === "string" ? size : "medium"}`,
      ].join(" ")}
    >
      <img
        height={height || getAvatarSize()}
        width={width || getAvatarSize()}
        src={src || avatar}
        alt="icon"
        className="thumbnail-image"
        style={{
          border: showBorder ? "2px solid #157bfb" : "none",
        }}
        onError={setInitials}
      />
    </AvatarContainer>
  );
};

Avatar.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["small", "medium", "large"]),
    PropTypes.number,
  ]),
  width: PropTypes.number,
  height: PropTypes.number,
  src: PropTypes.string,
  className: PropTypes.string,
  handleClick: PropTypes.func,
  showBorder: PropTypes.bool,
  name: PropTypes.string,
  round: PropTypes.bool,
};
